import React from 'react';
import PropTypes from 'prop-types';
import { ClipLoader } from 'react-spinners';
import i18n from '../../../assets/i18n';
import { FileIcon, DownloadIcon, ErrorIcon } from '../../atoms';
import { DocumentMessageBubbleStyled } from './styled';

const DocumentTemplateHeader = ({
  isFetching,
  isDownloadError,
  docSource,
  viewRef,
  multimediaFileName,
}) => {
  return (
    <DocumentMessageBubbleStyled ref={viewRef}>
      <div className="document-holder">
        <FileIcon className="icon-size icon-margin-right" />
        {isDownloadError ? (
          <>
            <p className="caption-text">
              {i18n.errors.documentFileNotAvailable}
            </p>
            <ErrorIcon className="error-icon" />
          </>
        ) : (
          <>
            <p className="caption-text">
              {multimediaFileName || i18n.chats.unknownDocumentCaption}
            </p>
            {isFetching ? (
              <div className="spinner-holder">
                <ClipLoader loading={isFetching} size={16} />
              </div>
            ) : (
              <a
                className="btn-download ts"
                href={docSource}
                rel="noopener noreferrer"
                target="_blank"
              >
                <DownloadIcon className="icon-size btn-icon ts" />
              </a>
            )}
          </>
        )}
      </div>
    </DocumentMessageBubbleStyled>
  );
};

DocumentTemplateHeader.propTypes = {
  docSource: PropTypes.string,
  isDownloadError: PropTypes.bool,
  isFetching: PropTypes.bool,
  multimediaFileName: PropTypes.string,
  viewRef: PropTypes.any,
};

export default DocumentTemplateHeader;
